import React from 'react';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {InlineEditableTable} from '../../../shared/components';
import type {IAssetsInlineTableProps} from '../financials.types';

const iconTrash = faTrash as IconProp;

export const AssetsInlineTable: React.FC<IAssetsInlineTableProps> = ({
  assetRows,
  assetCatalogue,
  assetConditions,
  isSavingAssets,
  onUpdateAssetRowField,
  onDeleteAsset,
}) => (
  <InlineEditableTable className="financials-assets__table-wrap">
    <table className="financials-assets-table">
      <thead>
        <tr>
          <th scope="col">Asset</th>
          <th scope="col">Condition</th>
          <th scope="col">Value</th>
          <th scope="col">Year</th>
          <th scope="col">Make</th>
          <th scope="col">Model</th>
          <th scope="col">Capacity</th>
          <th scope="col">Description</th>
          <th scope="col" aria-label="Actions" />
        </tr>
      </thead>
      <tbody>
        {assetRows.map((row) => (
          <tr key={row.localId}>
            <td>
              <select
                className="money-form-field__control financials-assets-table__cell-select"
                value={row.assetListId}
                onChange={(event) =>
                  onUpdateAssetRowField(
                    row.localId,
                    'assetListId',
                    event.target.value,
                  )
                }
                disabled={isSavingAssets}
              >
                <option value="">Select asset</option>
                {row.assetListId &&
                !assetCatalogue.some(
                  (item) => String(item.id) === row.assetListId,
                ) ? (
                  <option value={row.assetListId}>
                    {row.assetName || 'Current asset'}
                  </option>
                ) : null}
                {assetCatalogue.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </td>
            <td>
              <select
                className="money-form-field__control financials-assets-table__cell-select"
                value={row.condition}
                onChange={(event) =>
                  onUpdateAssetRowField(
                    row.localId,
                    'condition',
                    event.target.value,
                  )
                }
                disabled={isSavingAssets}
              >
                <option value="">Select condition</option>
                {assetConditions.map((conditionOption) => (
                  <option
                    key={conditionOption.value || 'unset'}
                    value={conditionOption.value}
                  >
                    {conditionOption.label}
                  </option>
                ))}
              </select>
            </td>
            <td>
              <input
                className="money-form-field__control financials-assets-table__cell-input"
                type="text"
                inputMode="decimal"
                value={row.value}
                onChange={(event) =>
                  onUpdateAssetRowField(
                    row.localId,
                    'value',
                    event.target.value,
                  )
                }
                disabled={isSavingAssets}
                placeholder="0.00"
              />
            </td>
            <td>
              <input
                className="money-form-field__control financials-assets-table__cell-input"
                type="text"
                value={row.year}
                onChange={(event) =>
                  onUpdateAssetRowField(row.localId, 'year', event.target.value)
                }
                disabled={isSavingAssets}
                placeholder="e.g. 2024"
              />
            </td>
            <td>
              <input
                className="money-form-field__control financials-assets-table__cell-input"
                type="text"
                value={row.make}
                onChange={(event) =>
                  onUpdateAssetRowField(row.localId, 'make', event.target.value)
                }
                disabled={isSavingAssets}
              />
            </td>
            <td>
              <input
                className="money-form-field__control financials-assets-table__cell-input"
                type="text"
                value={row.model}
                onChange={(event) =>
                  onUpdateAssetRowField(
                    row.localId,
                    'model',
                    event.target.value,
                  )
                }
                disabled={isSavingAssets}
              />
            </td>
            <td>
              <input
                className="money-form-field__control financials-assets-table__cell-input"
                type="text"
                value={row.capacity}
                onChange={(event) =>
                  onUpdateAssetRowField(
                    row.localId,
                    'capacity',
                    event.target.value,
                  )
                }
                disabled={isSavingAssets}
                placeholder={row.assetUnit ? `Value in ${row.assetUnit}` : ''}
              />
            </td>
            <td className="financials-assets-table__description">
              <textarea
                className="money-form-field__control financials-assets-table__cell-textarea"
                rows={2}
                value={row.description}
                onChange={(event) =>
                  onUpdateAssetRowField(
                    row.localId,
                    'description',
                    event.target.value,
                  )
                }
                disabled={isSavingAssets}
                placeholder="Optional notes"
              />
            </td>
            <td className="financials-assets-table__actions">
              <button
                type="button"
                className="btn btn-tertiary is-danger"
                onClick={() => {
                  onDeleteAsset(row);
                }}
                disabled={isSavingAssets}
              >
                <FontAwesomeIcon icon={iconTrash} aria-hidden="true" />
                <span>Delete</span>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </InlineEditableTable>
);
